var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.isUpdateHistoryAction,
        width: "600px",
        "before-close": _vm.handleClose,
        top: "10vh",
        close: _vm.handleClose,
        "custom-class": "modern-dialog",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isUpdateHistoryAction = $event
        },
        open: _vm.handleOpen,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "dialog-footer-themed" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        plain: "",
                        size: "medium",
                        icon: "el-icon-circle-close",
                      },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("\n        Đóng\n      ")]
                  ),
                  _vm.checkUpdate
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "medium",
                            icon: "el-icon-circle-check",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.handleUpload },
                        },
                        [_vm._v("\n        Lưu lại\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "dialog-header-themed" }, [
        _c("div", { staticClass: "themed-icon" }, [
          _c("i", {
            class: _vm.checkUpdate ? "el-icon-edit" : "el-icon-monitor",
          }),
        ]),
        _c("div", { staticClass: "themed-text" }, [
          _c("h3", [_vm._v(_vm._s(_vm.title))]),
          !_vm.checkUpdate
            ? _c("p", [
                _vm._v(
                  "Xem thông tin chi tiết và khóa nhận diện của hoạt động Cloud S3."
                ),
              ])
            : _c("p", [
                _vm._v(
                  "Cập nhật tên, loại, mã khóa và mô tả chi tiết của hoạt động Cloud S3."
                ),
              ]),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "formData",
          staticClass: "modern-dialog-form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-position": "top",
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-info" }),
                _vm._v(" Thông tin chung"),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Tên hoạt động", prop: "nameAction" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: !_vm.checkUpdate,
                              placeholder: "Nhập tên hoạt động",
                            },
                            model: {
                              value: _vm.formData.nameAction,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "nameAction", $$v)
                              },
                              expression: "formData.nameAction",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Loại tác vụ", prop: "typeAction" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: !_vm.checkUpdate,
                              placeholder: "Loại hoạt động",
                            },
                            model: {
                              value: _vm.formData.typeAction,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "typeAction", $$v)
                              },
                              expression: "formData.typeAction",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Mã hoạt động (Code)",
                            prop: "codeAction",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: "Mã hoạt động",
                            },
                            model: {
                              value: _vm.formData.codeAction,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "codeAction", $$v)
                              },
                              expression: "formData.codeAction",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("h4", { staticClass: "section-divider" }, [
                _c("i", { staticClass: "el-icon-notebook-2" }),
                _vm._v(" Mô tả chức năng"),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "descriptionAction" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRows: 8 },
                      disabled: !_vm.checkUpdate,
                      placeholder: "Mô tả cụ thể tác vụ hoạt động...",
                    },
                    model: {
                      value: _vm.formData.descriptionAction,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "descriptionAction", $$v)
                      },
                      expression: "formData.descriptionAction",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }